import { init, OAuth2Strategy } from 'bz-authentication-client'
import { RestApi } from './rest.api';
import { Injectable } from '@angular/core';
import { AuthenticationConfigModel, GetAuthenticationTypeModel } from './typings/AuthClient';
import { Observable } from 'rxjs';

/**
 * Accounts 2 Implementation
 */
@Injectable()
export class Accounts2ClientService {
  private instance: OAuth2Strategy;
  private authConfig: AuthenticationConfigModel;

  constructor(private _api: RestApi) {
  }

  async getInstance() {
    if (!this.instance) {
      this.instance = await init({ baseUrl: this.getPublicBaseUrl() + '/public/api/', urlInfo: '/AuthInfo/AuthInfo' }) as OAuth2Strategy;
    }
    return this.instance;
  }

  setAuthenticationConfig(config: AuthenticationConfigModel) {
    this.authConfig = config;
  }

  getAuthenticationConfig(): Partial<GetAuthenticationTypeModel> {
    return this.authConfig || { isAccounts2: false };
  }

  async logout() {
    return (await this.getInstance()).logout();
  }

  async refreshToken(): Promise<boolean> {
    return (await this.getInstance()).refreshToken();
  }

  async getToken() {
    return (await this.getInstance()).getToken();
  }

  public getProfile(): Observable<IUserProfile> {
    return this._api.get('api/AuthInfo/userProfile');
  }

  private getPublicBaseUrl() {
    const location = window.location;
    const initPathName = '/public/';
    return location.href.split(initPathName)[0].replace(location.hash, '').replace(location.search, '');
  }
}
